/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useContext, useRef, useCallback } from "react";
import { accountService } from "../../services/accountService";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import {
  GetPurchaseOrderMasterData,
  SetPurchaseOrderMasterData,
} from "../../store/purchaseOrderAtom";
// import CurrencyFormat from 'react-currency-format';
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { IoMdRefresh } from "react-icons/io";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { useForm } from "react-hook-form";
import moment from "moment";
import { purchaseService } from "../../services/purchase.service";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import PurchaseOrderFilter from "./PurchaseOrderFilter";
import StatusBadge from "../../generals/StatusBadge";


export const SalesTable = ({ tableData }) => {
  // const config = {
  //     sheetName: 'Sales Data',
  //     hostClass: ' spreadsheet',
  //     autoGenerateColumns: false,
  //     width: 200,
  //     visible: true,
  //     resizable: true,
  //     priceFormatter: '$ #.00',
  //     chartKey: 1
  // }
};


const columns = [
  {
    title: 'Id',
    key: 'Purchase_Order_Ref_No',
    dataIndex: 'Purchase_Order_Ref_No',
    sorter: (a, b) => (a?.Purchase_Order_Ref_No ?? '') - (b?.Purchase_Order_Ref_No ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Group Name',
    key: 'Order No',
    dataIndex: 'Purchase_Order_Number',
    className: "text-primary",
    sorter: (a, b) => (a?.Purchase_Order_Number ?? '').localeCompare(b?.Purchase_Order_Number ?? '')
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Order Date',
    dataIndex: 'Purchase_Order_Date_String',
    sorter: (a, b) => (a?.Purchase_Order_Date_String ?? '').localeCompare(b?.Purchase_Order_Date_String ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Delivery To',
    dataIndex: 'Delivery_To_Name',
    sorter: (a, b) => (a?.Delivery_To_Name ?? '').localeCompare(b?.Delivery_To_Name ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Delivery Name',
    dataIndex: 'Delivery_To_Type_Name',
    sorter: (a, b) => (a?.Delivery_To_Type_Name ?? '').localeCompare(b?.Delivery_To_Type_Name ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },


  {
    title: 'Expected Delivery',
    dataIndex: 'Expected_Delivery_Date_String',
    sorter: (a, b) => (a?.Expected_Delivery_Date_String ?? '').localeCompare(b?.Expected_Delivery_Date_String ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

 
  {
    title: 'Amount',
    dataIndex: 'Purchase_Order_Amount',
    sorter: (a, b) => (a?.Purchase_Order_Amount ?? '') - (b?.Purchase_Order_Amount ?? ''),
    render: (record) => <span >{formatCustomNumber(record)}</span>,
  },
 
  {
    title: 'PaymentTerm Name',
    dataIndex: 'Payment_Term_Name',
    sorter: (a, b) => (a?.Payment_Term_Name ?? '').localeCompare(b?.Payment_Term_Name ?? ''),
    render: (record) => <span className={`${record === 'Active' ? 'text-green-500' : record === 'Inactive' ? 'text-red-500' : ''}`}>
    {record}
  </span>,
  },
  {
    title: 'Status',
    dataIndex: 'Purchase_Order_Status_Name',
    sorter: (a, b) => (a?.Purchase_Order_Status_Name ?? '').localeCompare(b?.Purchase_Order_Status_Name ?? ''),
    render: (record, row) => (
      <StatusBadge statusId={row?.Purchase_Order_Status_Id} statusName={record} />
    ),
  },



];


function PurchaseOrderPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const logicContext = useContext(LogicContext);
  const setMasterData = SetPurchaseOrderMasterData();
  const getMasterData = GetPurchaseOrderMasterData();
  const myPromiseModal = createModal(GeneralModal);

  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const mountRef = useRef(false);
   const { register,   setValue,  getValues,  handleSubmit,  reset,
        formState: { errors }  } = useForm();
         const [searchText, setSearchText] = useState("");
  

  useEffect(() => {
    document.title = "Purchase Order";
    if (getMasterData["Purchase_Order_Info"]?.length > 0) {
      setTableData(getMasterData["Purchase_Order_Info"]);
    }else{
      getPurchaseOrderListApi();
    }
  }, [getMasterData]);



    // Handle session-based reload
    useEffect(() => {
      if (sessionStorage.getItem("reloadPage") === "true") {
        sessionStorage.removeItem("reloadPage");
        getPurchaseOrderListApi();
      }
    }, []);



      const searchByDate = async (event) => {
        const formData = getValues();
        const response = await purchaseService.getPurchaseOrderListByDate(formData);
        if (response?.data?.length) {
          setTableData(response?.data);
        } else {
          logicContext.showToast("No result found", "");
          setTableData([]);
        }
      };


  const getPurchaseOrderListApi = async () => {
    accountService.getPurchaseOrderList().then((response) => {
      if (response?.data !== undefined) {
        setMasterData(response.data);
      }
    });
  };




  const onActionFilterPerform = (event) => {
    const selectedIndex = event.target.value;
    
    const selection = getMasterData['Filtering_Criteria'][selectedIndex];
    if (Number(selection?.Filtering_Field_Value) === 0) {
      return setTableData(getMasterData['Purchase_Order_Info']);
    }
    var newList = getMasterData['Purchase_Order_Info'].filter(
      item => item.Purchase_Order_Status_Id === Number(selection?.Filtering_Field_Value)
    );
    if (newList.length) {
      setTableData(newList);
    } else {
      setTableData([]);
    }
  };

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }

  function addNewInvoice() {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }

  async function bulkActions(action) {
    await myPromiseModal({
      title: "confirm your action!",
      body: `Do you want to ${action.Action_Name} ?`,
      showInput: false,
      placeHolder: "",
    }).then((result) => {
      if (result.decision === true) {
        let temp = "";
        const option = action.Procedure_Option;
        itemSelected.map((item) => {
          temp += `<a> <refno> ${item.Purchase_Order_Ref_No} </refno> </a>`;
        });

        let xml_string_refno = `<root> ${temp} </root>`;
        accountService
          .setPurchaseBulkAction({ xml_string_refno, option })
          .then((res) => {
            if (res?.data !== undefined) {
              const { message_text } = res.data[0];
              logicContext.showToast(message_text, "success");
              return getPurchaseOrderListApi();
            }
          })
          .catch((err) => {
            logicContext.showToast("Error", "error");
          });
      }
    });
  }

  function OnItemCellClick(purchase) {
    const id = purchase["Purchase_Order_Ref_No"];
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
  }


  const handleSearch = text => {
    setSearchText(text);

    if (text.trim() === '') {
      setTableData(getMasterData['Purchase_Order_Info'] || []);
      return;
    }

    const searchTerm = text.toLowerCase();
    const filtered = (getMasterData['Purchase_Order_Info'] || []).filter(credit =>
      Object.values(credit).some(value => value?.toString().toLowerCase().includes(searchTerm))
    );
    setTableData(filtered);
  };




  const onClearInput = () => {
    setSearchText('');
    setTableData(getMasterData['Purchase_Order_Info'] || []);
  };



  return (
    <>
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center space-x-2">
          {itemSelected.length > 0 ? (
            <div className="col col-md-4 bg-black">
              <Dropdown>
                <Dropdown.Toggle
                  className="border-[1px] border-gray-200"
                  style={{
                    backgroundColor: '#E5E5E5',
                    border: 'none',
                    color: '#45444B',
                    fontSize: '12px',
                    height: '45px',
                  }}
                  id="dropdown-basic"
                >
                  Bulk Actions
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {getMasterData['Bulk_Action']?.map((action, i) => {
                    return (
                      <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                        {action.Action_Name}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          ) : (
            <PurchaseOrderFilter
              bulkActionData={toLowercaseKeys(getMasterData['Filtering_Criteria'])}
              onSelectBulkAction={onActionFilterPerform}
            />
          )}

          <Tooltip title="Reload">
            <div
              onClick={() => getPurchaseOrderListApi()}
              className="h-fit w-fit group flex items-center justify-center px-2.5 py-2.5 border-[1px] border-gray-200 bg-white rounded-md hover:bg-gray-200 cursor-pointer"
            >
              <IoMdRefresh className="h-6 w-6 text-gray-600 group-active:rotate-45 transition-all duration-300" />
            </div>
          </Tooltip>
        </div>

        {/* date search */}
        <div class="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm ">From Date:</span>
            <input
              defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
              {...register('from_date')}
              className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>

          <div>
            <span className="ml-1 text-sm ">To Date:</span>
            <input
              {...register('to_date')}
              defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
              className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <button onClick={() => searchByDate()} type="button" className="text-sm text-white px-3 bg-blue-500 rounded py-2.5">
              Search
            </button>
          </div>
        </div>
        {/* date search end */}

        <Tooltip title="Add New">
          <button
            onClick={addNewInvoice}
            className="h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
          >
            <FaPlus className="h-[16px] w-[16px] text-gray-600" />
          </button>
        </Tooltip>
      </div>

      {/* Start of search */}
      <div className="flex justify-center mt-4">
        <div className="flex flex-col w-full md:w-1/3">
          <input
            type="text"
            placeholder="Search in table"
            value={searchText}
            onKeyDown={e => {
              if (e.key === 'Backspace') {
                onClearInput();
              }
            }}
            onChange={e => handleSearch(e.target.value)}
            className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
          />
        </div>
      </div>
      {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true} // show checkBox for each row
          setSelectedRows={selectedTableItems}
          rowKey={record => record.Purchase_Order_Ref_No} // custom key
          handleRowClick={OnItemCellClick}
        />
      </section>
    </>
  );
}

export default PurchaseOrderPage;
